
const API = `https://api.smartcard.wacappcloud.com/`

export default API;
